import {Component, OnInit, Input} from '@angular/core';

import {WindowRefService} from '@app/core';
import {ICombineEngine, DetailPrice, IDetailsPrice} from '@app/shared';
import {chain, map} from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'app-details-price',
    templateUrl: './details-price.component.html',
    styleUrls: ['./details-price.component.scss']
})
export class DetailsPriceComponent implements OnInit {
    @Input() dates: {start: moment.Moment, end: moment.Moment};
    @Input() rooms: Array<IDetailsPrice>;
    detailTotal = {total: {Ttc: 0, Sale: 0, HT: 0}, byDays: []};

    constructor(private winRef: WindowRefService) {}

    ngOnInit() {
        let nbDays, listDates = this.enumerateDaysBetweenDates(this.dates.start.format('YYYY-MM-DD'), this.dates.end.format('YYYY-MM-DD'))
            ;
        listDates.map(d => {
            this.detailTotal.byDays.push({date: moment("".concat(d.replace(/-/g, '/'), " 00:00:00")), Ttc: 0, Sale: 0, HT: 0});
        })
        nbDays = this.dates.end.diff(this.dates.start, 'days');
        chain(this.rooms).map('engineSelected')
            .map((result: ICombineEngine) => {
                let price = this.winRef.appConfigSite.promo ? result.combine.detailPrice : result.combine.detailPrice_without_promo;
                this.detailTotal.total.Ttc += price.Ttc;
                this.detailTotal.total.Sale += price.Sale;
                this.detailTotal.total.HT += price.HT;
                map(this.detailTotal.byDays, (t: DetailPrice) => {
                    t.Ttc += price.Ttc / nbDays;
                    t.Sale += price.Sale / nbDays;
                    t.HT += price.HT / nbDays;
                })
                //result.alias.toLowerCase() != 'w'
                return result;
            })
            .value()
            ;
        console.log(this.detailTotal);
    }


    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }

    format(date: moment.Moment, format: string): string {
        return moment(date.format('YYYY-MM-DD 00:00:00')).format(format);
    }

    /**
     * get array dates
     * @returns Array<string>
     */
    private enumerateDaysBetweenDates(startdate: string, enddate: string): Array<string> {
        let startDate = moment(startdate),
            endDate = moment(enddate);

        var now = startDate, dates = [];

        while (now.isBefore(endDate) || now.isSame(endDate)) {
            dates.push(now.format('YYYY-MM-DD'));
            now.add(1, 'days');
        }
        dates.pop();
        return dates;
    }
}
